import { Component, inject, OnInit } from '@angular/core';
import { LocalScanningWebApiService } from '../../../services/local-scanning-web-api.service';
import { ActivatedRoute } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'eca-app-view-scan-image',
  templateUrl: './view-scan-image.component.html',
  styleUrls: ['./view-scan-image.component.css'],
  imports: [AsyncPipe]
})
export class ViewScanImageComponent implements OnInit {
  private webapi = inject(LocalScanningWebApiService);
  private route = inject(ActivatedRoute);


  public scanId;
  public signedUrl$;

  ngOnInit() {
    this.scanId = decodeURIComponent(this.route.snapshot.params.scanId);
    this.signedUrl$ = this.webapi.getScanImageUrl(this.route.snapshot.params.scanId);
  }
}
